const PH_MOBILE_ERROR = "Use a Philippine mobile number such as +639171234567";

export function normalizePhilippinePhone(value: string): string | undefined {
  const trimmed = value.trim();
  if (!trimmed) return undefined;

  const digits = trimmed.replace(/\D/g, "");
  if (/^09\d{9}$/.test(digits)) return `+63${digits.slice(1)}`;
  if (/^639\d{9}$/.test(digits)) return `+${digits}`;
  if (/^9\d{9}$/.test(digits)) return `+63${digits}`;
  throw new Error(PH_MOBILE_ERROR);
}

export function formatPhilippinePhoneInput(value: string): string {
  const digits = value.replace(/\D/g, "").slice(0, 12);
  if (digits.startsWith("63")) return `+${digits}`;
  if (digits.startsWith("09")) return `+63${digits.slice(1)}`;
  if (digits.startsWith("9")) return `+63${digits}`;
  return digits;
}
